/**
 * Live /apply-now — same flow as /apply-loan
 *   Mobile → PAN + DigiLocker Aadhaar → Loan form → Thank You
 *
 * TEMP 31 Oct 2026: 3rd-party mobile OTP is down.
 * skipMobileOtp collects the mobile number and continues without send/verify OTP.
 * Restore tomorrow: remove the skipMobileOtp prop (backups below are today's OTP flow).
 *
 * Backups (31 Oct 2026, with OTP):
 *   apply-now-backup-with-mobile-otp-20261031.js
 *   apply-loan-backup-with-mobile-otp-20261031.js
 *   ApplyNowSteps/MobileOtpStep1-backup-with-otp-20261031.js
 *
 * Differences from /apply-loan:
 *   - DigiLocker opens in the same tab (no popup)
 *   - State / city / pincode are not prefilled from Aadhaar
 *   - Mobile OTP is skipped for today only
 */
import React from "react";
import ApplyLoan from "./apply-loan";

const ApplyNow = () => (
  <ApplyLoan sameTabDigilocker prefillLocation={false} skipMobileOtp />
);

export default ApplyNow;
